import USDt from "../common/usdt";

export const polimecUSDt = {
  id: 1984,
  height: 1151155,
  ...USDt,
};

export default polimecUSDt;
